import React from 'react';
import cn from 'classnames/bind';

import SearchTable from '../../components/SearchTable/SearchTable';
import SearchTableHead from '../../components/SearchTableHead/SearchTableHead';
import SearchTableHeadCell from '../../components/SearchTableHeadCell/SearchTableHeadCell';
import DatepickerTableHeadCell from '../../components/DatepickerTableHeadCell/DatepickerTableHeadCell';
import SearchTableBody from '../../components/SearchTableBody/SearchTableBody';
import SearchTableBodyCell from '../../components/SearchTableBodyCell/SearchTableBodyCell';
import Sprite from '../../../../components/Sprite';

import styles from './ResearchesSearchTable.module.css';
import { transformTimeDate } from '../../../../utils/dates';

const cx = cn.bind(styles);

function ResearchesSearchTable(props) {
  function handleRowClick(id) {
    props.history.push(`/laboratory-research/${id}`);
  }

  function handleOrderClick(name, values, actions) {
    if (values.orderBy === name) {
      actions.setFieldValue('orderBy', `-${name}`);
      props.onFilter({ ...values, orderBy: `-${name}` }, actions);
    } else {
      actions.setFieldValue('orderBy', name);
      props.onFilter({ ...values, orderBy: name }, actions);
    }
  }

  return (
    <section className={styles.wrapper}>
      <SearchTable>
        <SearchTableHead rowClassName={cx({ 'table-row': true })}>
          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="id"
            icon="magnifier"
            actions={props.actions}
          >
            № исследования
          </SearchTableHeadCell>

          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="title"
            icon="magnifier"
            actions={props.actions}
          >
            Название
          </SearchTableHeadCell>

          <DatepickerTableHeadCell
            className={cx({ 'table-cell': true })}
            name="date"
            icon="calendar"
            actions={props.actions}
            value={props.values.date}
          >
            Дата
          </DatepickerTableHeadCell>

          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="goatChip"
            icon="magnifier"
            actions={props.actions}
          >
            Номер чипа
          </SearchTableHeadCell>

          <SearchTableHeadCell
            className={cx({ 'table-cell': true })}
            name="goatName"
            icon="magnifier"
            actions={props.actions}
          >
            Кличка
          </SearchTableHeadCell>

          <DatepickerTableHeadCell
            className={cx({ 'table-cell': true })}
            name="modified"
            icon="calendar"
            actions={props.actions}
            value={props.values.modified}
          >
            <button
              type="button"
              icon="magnifier"
              onClick={() => handleOrderClick('modified', props.values, props.actions)}
              className={cx({ 'button-text': true })}
            >
              Обновлено
              <Sprite
                name="sort-arrow"
                role="img"
                className={cx({
                  arrow: true,
                  'arrow-ordered': props.values.orderBy === '-modified',
                })}
              />
            </button>
          </DatepickerTableHeadCell>
        </SearchTableHead>

        <SearchTableBody results={props.researches.results.length}>
          {props.researches.results.map(({ id, title, date, goatChip, goatName, modified }) => {
            date = date ? transformTimeDate(date, 'dmy') : date;
            modified = modified ? transformTimeDate(modified, 'dmyt', 9) : modified;

            return (
              <tr
                key={id}
                onClick={() => handleRowClick(id)}
                className={cx({ 'table-row': true, 'table-body-row': true })}
              >
                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {id}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {title}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {date}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {goatChip}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {goatName}
                </SearchTableBodyCell>

                <SearchTableBodyCell className={cx({ 'table-cell': true })}>
                  {modified}
                </SearchTableBodyCell>
              </tr>
            );
          })}
        </SearchTableBody>
      </SearchTable>

      <div className={styles.footer}>{props.children}</div>
    </section>
  );
}

export default ResearchesSearchTable;
